import { render, staticRenderFns } from "./CoAlert.vue?vue&type=template&id=20c3dcda&scoped=true&"
import script from "./CoAlert.vue?vue&type=script&lang=ts&"
export * from "./CoAlert.vue?vue&type=script&lang=ts&"
import style0 from "./CoAlert.vue?vue&type=style&index=0&id=20c3dcda&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c3dcda",
  null
  
)

export default component.exports